export const customer = {
  Sex: [{
    value: 0, label: '未知'
  }, {
    value: 1, label: '男'
  }, {
    value: 2, label: '女'
  }],
  userStatus: [{
    value: 0, label: '未知'
  }, {
    value: 1, label: '正常'
  }, {
    value: 8, label: '禁用'
  }],
  CustomerSeatType: [{ // 人员坐席类型
    value: 0, label: '全部'
  }, {
    value: 1, label: '标准'
  }, {
    value: 2, label: '智能'
  }],
  certificateType: [
    { value: 1, label: '身份证' },
    { value: 2, label: '护照' },
    { value: 3, label: '军官证' },
    { value: 5, label: '回乡证' },
    { value: 6, label: '台胞证' },
    { value: 7, label: '港澳通行证' },
    { value: 9, label: '临时身份证' },
    { value: 10, label: '户口簿' },
    { value: 11, label: '社保证' },
    { value: 12, label: '驾驶证' },
    { value: 13, label: '港澳身份证' },
    { value: 14, label: '赴台通行证' },
    { value: 15, label: '士兵证' },
    { value: 16, label: '港澳回乡证或台胞证' },
    { value: 17, label: '军人证' }
  ],
  certificateTypeHasOther: [
    { value: 1, label: '身份证' },
    { value: 2, label: '护照' },
    { value: 3, label: '军官证' },
    { value: 5, label: '回乡证' },
    { value: 6, label: '台胞证' },
    { value: 7, label: '港澳通行证' },
    { value: 9, label: '临时身份证' },
    { value: 10, label: '户口簿' },
    { value: 11, label: '社保证' },
    { value: 12, label: '驾驶证' },
    { value: 13, label: '港澳身份证' },
    { value: 14, label: '赴台通行证' },
    { value: 15, label: '士兵证' },
    { value: 16, label: '港澳回乡证或台胞证' },
    { value: 17, label: '军人证' },
    { value: 18, label: '外国人永久居留身份证' },
    { value: 99, label: '其他' }
  ],
  academicArr: [
    { value: '0', label: '博士' },
    { value: '1', label: '硕士' },
    { value: '7', label: '研究生' },
    { value: '2', label: '本科' },
    { value: '3', label: '大专' },
    { value: '8', label: '中专' },
    { value: '4', label: '高中及同等学历' },
    { value: '5', label: '初中及同等学历' },
    { value: '6', label: '初中及以下学历' },
    { value: '9', label: '其他' }
  ],
  nation: [
    { value: 1, label: '汉族' }, { value: 2, label: '壮族' }, { value: 3, label: '满族' }, { value: 4, label: '回族' }, { value: 5, label: '苗族' },
    { value: 6, label: '维吾尔族' }, { value: 7, label: '土家族' }, { value: 8, label: '彝族' }, { value: 9, label: '蒙古族' }, { value: 10, label: '藏族' },
    { value: 11, label: '布依族' }, { value: 12, label: '侗族' }, { value: 13, label: '瑶族' }, { value: 14, label: '朝鲜族' }, { value: 15, label: '白族' },
    { value: 16, label: '哈尼族' }, { value: 17, label: '哈萨克族' }, { value: 18, label: '黎族' }, { value: 19, label: '傣族' }, { value: 20, label: '畲族' },
    { value: 21, label: '傈僳族' }, { value: 22, label: '仡佬族' }, { value: 23, label: '东乡族' }, { value: 24, label: '高山族' }, { value: 25, label: '拉祜族' },
    { value: 26, label: '水族' }, { value: 27, label: '佤族' }, { value: 28, label: '纳西族' }, { value: 29, label: '羌族' }, { value: 30, label: '土族' },
    { value: 31, label: '仫佬族' }, { value: 32, label: '锡伯族' }, { value: 33, label: '柯尔克孜族' }, { value: 34, label: '达斡尔族' }, { value: 35, label: '景颇族' },
    { value: 36, label: '毛南族' }, { value: 37, label: '撒拉族' }, { value: 38, label: '布朗族' }, { value: 39, label: '塔吉克族' }, { value: 40, label: '阿昌族' },
    { value: 41, label: '普米族' }, { value: 42, label: '鄂温克族' }, { value: 43, label: '怒族' }, { value: 44, label: '京族' }, { value: 45, label: '基诺族' },
    { value: 46, label: '德昂族' }, { value: 47, label: '保安族' }, { value: 48, label: '俄罗斯族' }, { value: 49, label: '裕固族' }, { value: 50, label: '乌孜别克族' },
    { value: 51, label: '门巴族' }, { value: 52, label: '鄂伦春族' }, { value: 53, label: '独龙族' }, { value: 54, label: '塔塔尔族' }, { value: 55, label: '赫哲族' },
    { value: 56, label: '珞巴族' }
  ],
  politicalStatus: [
    { value: 1, label: '中共党员' },
    { value: 2, label: '共青团员' },
    { value: 3, label: '群众' },
    { value: 4, label: '中共预备党员' },
    { value: 5, label: '民建会员' },
    { value: 6, label: '农工党党员' },
    { value: 7, label: '其他' },
    { value: 8, label: '无党派人士' }
  ],
  registerArr: [
    { value: 1, label: '城镇户籍' },
    { value: 2, label: '农村户籍' },
    { value: 3, label: '外籍' }
  ],
  timeList: [
    { label: '昨天', value: '2' },
    { label: '今天', value: '1' }
  ],
  chartTabs: [
    { label: '单量', value: '0' },
    { label: '保费', value: '1' },
    { label: '商保费', value: '2' },
    { label: '交保费', value: '3' },
    { label: '车船税', value: '4' },
    { label: '非车保费', value: '5' },
    { label: '随车非车保费', value: '6' }
  ]
}

export default {
  customer
}



// WEBPACK FOOTER //
// ./src/data/customer.js